var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectFloor1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "2500px",
    height: "1271px",
    viewBox: "0 0 2500 1271",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "A",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    id: 1,
    d: "M650.16826,141.846399 L650.16826,169.940727 L643.871256,169.940727 L643.871256,215.472913 L639.027406,215.472913 L639.027406,400.992352 L632.246017,400.992352 L632.246017,607.340344 L663.246654,607.340344 L663.246654,630.590822 L643.871256,630.590822 L643.871256,931.393881 L391.506692,931.393881 L391.506692,141.846399 L650.16826,141.846399 Z",
    stroke: "#FFD426",
    strokeWidth: 2.90630975,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: 2,
    d: "M886.063735,141.846399 L886.063735,170.909496 L862.328872,170.909496 L862.328872,376.773104 L893.813894,376.773104 L893.813894,400.992352 L871.532186,400.992352 L871.532186,836.45443 L886.063735,836.45443 L886.063735,931.393881 L646.777565,931.393881 L646.777565,633.497132 L666.152964,633.497132 L666.152964,604.434034 L635.152326,604.434034 L635.152326,403.898662 L641.933716,403.898662 L641.933716,218.379222 L646.777565,218.379222 L646.777565,172.847036 L653.07457,172.847036 L653.07457,141.846399 L886.063735,141.846399 Z",
    stroke: "#FFD426",
    strokeWidth: 2.90630975,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: 3,
    d: "M1105.00574,384.038878 L1105.00574,858.736138 L998.92543,858.736138 L998.92543,865.033142 L967.440408,865.033142 L967.440408,758.468451 L945.643085,758.468451 L945.643085,400.507967 L937.892925,400.507967 L937.892925,384.038878 L1105.00574,384.038878 Z",
    stroke: "#FFD426",
    strokeWidth: 2.90630975,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: 4,
    d: "M1331.21351,142.815169 L1331.21351,858.736138 L1107.91205,858.736138 L1107.91205,381.132569 L1085.63034,381.132569 L1085.63034,142.815169 L1331.21351,142.815169 Z",
    stroke: "#FFD426",
    strokeWidth: 2.90630975,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: 5,
    d: "M1568.07776,142.815169 L1568.07776,215.472913 L1558.88676,215.472913 L1557.89325,332.209688 L1563.23391,332.209688 L1563.23391,377.257489 L1583.09369,377.257489 L1583.09369,400.992352 L1557.90567,400.992352 L1557.90567,606.855959 L1583.09369,606.855959 L1583.09369,630.590822 L1563.23391,630.590822 L1563.23391,858.736138 L1334.11982,858.736138 L1334.11982,142.815169 L1568.07776,142.815169 Z",
    stroke: "#FFD426",
    strokeWidth: 2.90630975,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: 6,
    d: "M1805.42639,142.815169 L1805.42639,170.909496 L1783.14468,170.909496 L1783.14468,377.174521 L1791.37922,377.658906 L1791.37922,858.736138 L1566.14022,858.736138 L1566.14022,633.497132 L1586,633.497132 L1586,603.949649 L1560.81198,603.949649 L1560.81198,403.898662 L1586,403.898662 L1586,374.351179 L1566.14022,374.351179 L1566.14022,329.303378 L1560.8244,329.303378 L1561.76844,218.379222 L1570.98407,218.379222 L1570.98407,142.815169 L1805.42639,142.815169 Z",
    stroke: "#FFD426",
    strokeWidth: 2.90630975,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: 7,
    d: "M2024.36839,384.038878 L2024.36839,630.590822 L2016.12145,630.590822 L2018.05899,858.736138 L1859.22139,858.736138 L1859.40219,849.353239 L1886.80306,849.542918 L1886.80306,758.952836 L1865.49012,758.952836 L1865.49012,384.038878 L2024.36839,384.038878 Z",
    stroke: "#FFD426",
    strokeWidth: 2.90630975,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: 8,
    d: "M2262.66937,387.429573 L2257.37379,858.736138 L2020.9654,858.736138 L2019.05255,633.497132 L2027.2747,633.497132 L2027.2747,393.726577 L2179.37157,393.726577 L2179.37157,387.429573 L2262.66937,387.429573 Z",
    stroke: "#FFD426",
    strokeWidth: 2.90630975,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: 9,
    d: "M2262.68579,142.815169 L2262.68579,384.523263 L2176.46526,384.523263 L2176.46526,390.820268 L2111.55768,390.820268 L2111.55768,142.815169 L2262.68579,142.815169 Z",
    stroke: "#FFD426",
    strokeWidth: 2.90630975,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: 10,
    d: "M2108.65137,142.815169 L2108.65137,390.820268 L2027.2747,390.820268 L2027.2747,384.523263 L2004.99299,384.523263 L2004.99299,142.815169 L2108.65137,142.815169 Z",
    stroke: "#FFD426",
    strokeWidth: 2.90630975,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectFloor1);
export default __webpack_public_path__ + "static/media/select-floor-1.116a9dca.svg";
export { ForwardRef as ReactComponent };